import { SingleOption } from '@frontend/components/basic-forms';
import { UserState, UserStateName } from '@frontend/user/types';
import { useMemo } from 'react';

import { UserStateSelectV2Props } from './user-state-select-v2.component';

interface ViewProps {
    options: SingleOption<UserStateName>[];
}

const useUserStateSelectV2 = (props: UserStateSelectV2Props): ViewProps => {
    const options = useMemo(() => {
        const stateOptions = UserState.ALL.filter((state) => state.value !== UserStateName.USER_ANY_STATE)
            .filter((state) => (props.subset ? props.subset.includes(state.value) : true))
            .map((state) => ({
                value: state.value,
                label: state.value,
                display: state.displayName
            }));

        return [
            ...(props.includeAnyState
                ? [
                      {
                          value: UserStateName.USER_ANY_STATE,
                          label: props.anyStateLabel ?? UserStateName.USER_ANY_STATE,
                          display: props.anyStateDisplay ?? UserState.USER_ANY_STATE.displayName
                      }
                  ]
                : []),
            ...stateOptions
        ];
    }, [props.subset, props.includeAnyState, props.anyStateLabel, props.anyStateDisplay]);

    return { options };
};

export default useUserStateSelectV2;
